import { format } from "date-fns";

import type { InputOutputFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/types/input-output-form";
import type { InputOutputFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/input-output/zod-schemas/input-output-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty form values with blank date/time for QuestionnaireResponse hydrate. */
export function getEmptyInputOutputFlowsheetFormValues(): InputOutputFlowsheetFormValues {
  return {
    inputOutputDate: null,
    inputOutputTime: null,
    inputOutputInput: "",
    inputOutputOutput: "",
    inputOutputNotes: "",
    signatureInitials: [],
  };
}

/** Quick-add defaults with the current local date and time. */
export function getDefaultInputOutputFlowsheetFormValues(): InputOutputFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyInputOutputFlowsheetFormValues(),
    inputOutputDate: now,
    inputOutputTime: localToUtcTimeString(localTime),
  };
}

export function normalizeInputOutputFlowsheetFormValues(
  parsed: InputOutputFlowsheetFormSchemaType,
): InputOutputFlowsheetFormValues {
  // Keep explicit null date/time so edit hydrate does not fill the current clock.
  const empty = getEmptyInputOutputFlowsheetFormValues();
  return {
    inputOutputDate:
      parsed.inputOutputDate !== undefined ? parsed.inputOutputDate : empty.inputOutputDate,
    inputOutputTime:
      parsed.inputOutputTime !== undefined ? parsed.inputOutputTime : empty.inputOutputTime,
    inputOutputInput: parsed.inputOutputInput ?? empty.inputOutputInput,
    inputOutputOutput: parsed.inputOutputOutput ?? empty.inputOutputOutput,
    inputOutputNotes: parsed.inputOutputNotes ?? empty.inputOutputNotes,
    signatureInitials: parsed.signatureInitials ?? empty.signatureInitials,
  };
}
